import { AvatarSize, Owner } from '../../utils/customTypes';
import UserAvatar from '../../Atoms/UserAvatar';
import get from 'lodash/get';
import { AvatarGroup } from '@getsynapse/design-system';
import { isUserStatusDisabled } from '../../utils/functions';
import intl from 'react-intl-universal';

export const getUserAvartarColumn = (
  owners: Owner[],
  size: AvatarSize = 'small',
  hideName: boolean = false
) => {
  if (owners.length === 1 && !hideName) {
    return (
      <div className='flex items-center'>
        <UserAvatar
          size={size}
          user={{
            avatar_url: owners[0].avatar_url,
            status: owners[0].status,
            data: {
              firstName: get(owners[0], 'data.firstName'),
              lastName: get(owners[0], 'data.lastName'),
            },
          }}
          className='mr-2.5'
        />
        {`${get(owners, '0.data.firstName')} ${get(owners, '0.data.lastName')}`}
      </div>
    );
  } else {
    return (
      <AvatarGroup
        avatars={owners.map((owner) => {
          const firstName = get(owner, 'data.firstName');
          const lastName = get(owner, 'data.lastName');
          return {
            size: 'medium',
            imageSrc: owner.avatar_url,
            initial: get(firstName, '[0]'),
            name: `${firstName} ${lastName}`,
            disabled: isUserStatusDisabled(owner.status),
          };
        })}
        deactivatedText={intl.get('DEACTIVATED')}
      />
    );
  }
};
